"use strict";

exports.__esModule = true;
exports.isQuestion = exports.isDiscussion = exports.QUESTION = exports.DISCUSSION = void 0;
var DISCUSSION = 'discussion';
exports.DISCUSSION = DISCUSSION;
var QUESTION = 'question';
exports.QUESTION = QUESTION;

var isDiscussion = function isDiscussion(postType) {
  if (postType === void 0) {
    postType = DISCUSSION;
  }

  return postType === DISCUSSION;
};

exports.isDiscussion = isDiscussion;

var isQuestion = function isQuestion(postType) {
  return postType === QUESTION;
};

exports.isQuestion = isQuestion;